import styled from 'styled-components';
import { Modal } from 'antd';
import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
    border-radius: 8px !important;
    padding: 0 !important;
  }

  .ant-modal-header {
    background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
    border-bottom: 1px solid ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
    padding: 16px 24px !important;
    border-radius: 8px 8px 0 0 !important;
  }

  .ant-modal-title {
    color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
  }

  .ant-modal-close {
    color: ${(props) => getThemeValue(props, '#a0aec0', '#8c8c8c')} !important;
    top: 16px !important;
    right: 16px !important;

    &:hover {
      color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
    }
  }

  .ant-modal-body {
    padding: 0 !important;
    background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  min-height: 400px;
  max-height: 80vh;
  overflow: hidden;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 100%;
  max-height: 80vh;
  display: block;
`;

export const FallbackContainer = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => getThemeValue(props, '#2d3748', '#f7fafc')} !important;
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
`;

export const SkeletonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;

  .ant-skeleton-image {
    width: 100% !important;
    height: 400px !important;
    max-height: 80vh !important;
  }

  .ant-skeleton-image-svg {
    width: 100% !important;
    height: 100% !important;
  }
`;
